export default __webpack_public_path__ + "static/media/Light.3a8a1b35.ttf";